import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4e8ceac4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "file-page" }
const _hoisted_2 = { class: "list ws_common_table" }

import { onMounted, ref } from 'vue'
import { queryFilePage, queryFileDetail, deleteFile } from '@/api'
import { PAGE_SIZES, CODE_ENUM, FILE_TYPE, FILE_CONTENT_TYPE } from '@/common'
import { isEmpty } from 'lodash'
import { ElMessage } from 'element-plus'
import AdvancedQueryLayout from '@/components/advanced-query-layout'
import { useRouter } from 'vue-router'
import OperationButtonList from '@/components/operation-button-list'
import moment from 'moment'
import Preview from './components/preview-modal.vue'
import { msgbox, getDate, formatFormTime } from '@/utils'
import Selecttenant from '@/components/select-tenant'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const router = useRouter()

const advancedRef = ref()

const getButtonList = ({ previewFlag }: any) => {
  const buttonList = [
    {
      type: 'edit',
      text: '预览',
      disabled: !previewFlag,
    },
    {
      type: 'detail',
      text: '下载',
    },
  ]

  return buttonList.filter(({ show }: any) => {
    return show !== false
  })
}

const shortcuts = [
  {
    text: '今天',
    value: getDate(1, 'D'),
  },
  {
    text: '最近一个月',
    value: getDate(1, 'M'),
  },
  {
    text: '最近三个月',
    value: getDate(3, 'M'),
  },
  {
    text: '最近半年',
    value: getDate(6, 'M'),
  },
  {
    text: '最近一年',
    value: getDate(12, 'M'),
  },
]

const columns = [
  {
    prop: 'name',
    label: '文件名称',
  },
  {
    prop: 'typeValue',
    label: '文件类型',
  },
  {
    prop: 'contentTypeValue',
    label: '内容类型',
  },
  {
    prop: 'createDate',
    label: '采集时间',
    formatter: ({ createDate }: any) => {
      return moment(createDate).format('YYYY-MM-DD HH:mm:ss')
    },
  },
  {
    prop: 'sizeStr',
    label: '文件大小',
  },
  {
    prop: 'deviceSn',
    label: '设备SN',
  },
]

const contentTypeList: any = [
  {
    label: '珍稀动物',
    value: FILE_CONTENT_TYPE.RARE_ANIMAL,
  },
  {
    label: '火灾',
    value: FILE_CONTENT_TYPE.FIRE,
  },
]

const fileTypeList: any = [
  {
    label: '文本',
    value: FILE_TYPE.TEXT,
  },
  {
    label: '图片',
    value: FILE_TYPE.IMAGE,
  },
  {
    label: '视频',
    value: FILE_TYPE.VIDEO,
  },
  {
    label: '音频',
    value: FILE_TYPE.AUDIO,
  },
  // {
  //   label: '其他',
  //   value: FILE_TYPE.OTHER,
  // },
]

const timeValidator = (rule: any, value: any, callback: any) => {
  if (isEmpty(value)) {
    callback()
  } else {
    const [start, end] = value
    if (
      moment(end).valueOf() - moment(start).valueOf() >
      1000 * 60 * 60 * 24 * 367
    ) {
      callback('时间跨度不能超过一年')
    } else {
      callback()
    }
  }
}

const before = async () => {
  return new Promise((reslove) => {
    advancedRef.value.formRef.validate((valid: boolean) => {
      reslove(valid)
    })
  })
}

const rules: any = {
  createTime: [{ validator: timeValidator }],
}

const tableData: any = ref([])
const formInline = ref({
  name: '',
  orgId: undefined,
  createTime: undefined,
})

const pageParams = ref({
  curPage: 1,
  pageSize: 10,
})
const total = ref(0)

const handleSizeChange = () => {
  pageParams.value.curPage = 1
  fetchList()
}
const handleCurrentChange = () => {
  fetchList()
}

const getMoTime = (keepAliveData: any) => {
  return {
    ...formatFormTime(keepAliveData.createTime, [
      'createStartTime',
      'createEndTime',
    ]),
  }
}

const tableLoading = ref(false)

const fetchList = async (queryData?: any) => {
  const keepAliveData = advancedRef.value.getKeepAliveData()
  const moTime = getMoTime(keepAliveData)

  const { data, reset } = queryData || {}

  if (typeof reset === 'boolean') {
    pageParams.value.curPage = 1
  }
  tableLoading.value = true

  const res: any = await queryFilePage({
    ...pageParams.value,
    ...data,
    ...keepAliveData,
    ...moTime,
  }).finally(() => {
    tableLoading.value = false
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    tableData.value = res?.data?.records || []
    total.value = res?.data?.total || 0
  }
}
onMounted(() => {
  fetchList()
})

const priviewConf = ref({
  visible: false,
  data: {},
})
const toPriview = (data: any) => {
  priviewConf.value = {
    visible: true,
    data,
  }
}

const downloadFile = async ({ id }: any) => {
  const res: any = await queryFileDetail({
    id,
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    const a = document.createElement('a')
    a.href = res?.data?.previewUrl
    a.dispatchEvent(
      new MouseEvent('click', { bubbles: true, cancelable: true, view: window })
    )
  }
}

const toDelete = (row: any) => {
  msgbox({
    tip: '您确定要删除这个文件吗',
    thenFn: () => handleDelete(row),
  })
}

const handleDelete = async ({ id }: any) => {
  const res: any = await deleteFile({ id })
  if (res?.code === CODE_ENUM.SUCCESS) {
    ElMessage.success(res?.msg)
    fetchList()
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(AdvancedQueryLayout), {
        ref_key: "advancedRef",
        ref: advancedRef,
        model: formInline.value,
        onFetchList: fetchList,
        "label-width": 92,
        border: true,
        before: before,
        rules: rules
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "租户",
            prop: "orgId"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Selecttenant), {
                modelValue: formInline.value.orgId,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formInline.value.orgId) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "文件名称",
            prop: "name"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: formInline.value.name,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formInline.value.name) = $event)),
                clearable: "",
                maxlength: "50",
                class: "ws_select"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "设备SN",
            prop: "deviceSn"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: formInline.value.deviceSn,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formInline.value.deviceSn) = $event)),
                clearable: "",
                maxlength: "50",
                class: "ws_select"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "文件类型",
            prop: "type"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: formInline.value.type,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formInline.value.type) = $event)),
                class: "ws_select",
                clearable: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(fileTypeList, (item) => {
                    return _createVNode(_component_el_option, {
                      key: item.value,
                      label: item.label,
                      value: item.value
                    }, null, 8, ["label", "value"])
                  }), 64))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "内容类型",
            prop: "contentType"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: formInline.value.contentType,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formInline.value.contentType) = $event)),
                class: "ws_select",
                clearable: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(contentTypeList, (item) => {
                    return _createVNode(_component_el_option, {
                      key: item.value,
                      label: item.label,
                      value: item.value
                    }, null, 8, ["label", "value"])
                  }), 64))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "上报时间",
            prop: "createTime"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_date_picker, {
                modelValue: formInline.value.createTime,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formInline.value.createTime) = $event)),
                "unlink-panels": "",
                type: "datetimerange",
                "range-separator": "-",
                "start-placeholder": "开始时间",
                "end-placeholder": "结束时间",
                shortcuts: shortcuts,
                editable: false
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"]),
      _createElementVNode("div", _hoisted_2, [
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          data: tableData.value,
          stripe: "",
          class: "ws_mt20 device-table"
        }, {
          empty: _withCtx(() => [
            _createVNode(_component_el_empty, { description: '暂无数据' })
          ]),
          default: _withCtx(() => [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(columns, (item) => {
              return _createVNode(_component_el_table_column, _mergeProps({
                key: item.prop
              }, {
            ...item,
          }, { "show-overflow-tooltip": "" }), null, 16)
            }), 64)),
            _createVNode(_component_el_table_column, {
              prop: "operation",
              label: '操作',
              width: "280"
            }, {
              default: _withCtx((scope) => [
                _createVNode(_unref(OperationButtonList), {
                  buttonList: getButtonList(scope.row),
                  scope: scope.row,
                  onOnEdit: toPriview,
                  onOnDelete: toDelete,
                  onOnDetail: downloadFile
                }, null, 8, ["buttonList", "scope"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, tableLoading.value]
        ]),
        _createVNode(_component_el_pagination, {
          class: "ws_mt50",
          "current-page": pageParams.value.curPage,
          "onUpdate:currentPage": _cache[6] || (_cache[6] = ($event: any) => ((pageParams.value.curPage) = $event)),
          "page-size": pageParams.value.pageSize,
          "onUpdate:pageSize": _cache[7] || (_cache[7] = ($event: any) => ((pageParams.value.pageSize) = $event)),
          "page-sizes": _unref(PAGE_SIZES),
          layout: "->, total, sizes, prev, pager, next, jumper ",
          total: total.value,
          onSizeChange: handleSizeChange,
          onCurrentChange: handleCurrentChange
        }, null, 8, ["current-page", "page-size", "page-sizes", "total"])
      ])
    ]),
    _createVNode(Preview, {
      visible: priviewConf.value.visible,
      "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((priviewConf.value.visible) = $event)),
      data: priviewConf.value.data
    }, null, 8, ["visible", "data"])
  ], 64))
}
}

})